import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Loader from './components/ui/Loader';
import { CONTENT_EVENT, loadRemoteContent } from './data/remote';

/** Re-mounts the app once if admin content arrives after the first render. */
const Root = () => {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const bump = () => setVersion((v) => v + 1);
    window.addEventListener(CONTENT_EVENT, bump);
    return () => window.removeEventListener(CONTENT_EVENT, bump);
  }, []);
  return (
    <>
      {/* Brand intro for visitors (once per visit); admin staff go straight to work. Kept outside
          the keyed app so a late content refresh doesn't replay it. */}
      {!window.location.pathname.startsWith('/admin') && <Loader />}
      <App key={version} />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Pull in anything edited in the admin first (waits at most a moment).
loadRemoteContent().finally(() => {
  root.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  );
});
